import React, { useEffect, useState } from 'react'
import Compressor from 'compressorjs';
import AWS from "aws-sdk";
import useImageConfigS3 from '../HelperComponent/useImageConfigS3';

const useCoverChange = (file=null,upKey=null,delKey=null) => {

    const [s3,bucketName] = useImageConfigS3([]);
    const [coverProgress, setCoverProgress] = useState(0);
    const [coverUrl, setcoverUrl] = useState('');
    const [coverKey, setCoverKey] = useState('');

    const [uploadFile, setFile] = useState(null);
    const [delelecoverKey, setDeleteFile] = useState(null);


    useEffect(() => {
      setFile(file);
      setDeleteFile(delKey);
      setCoverProgress(0);
    }, [file,delKey]);


      const handleDelete = (delFile) => {

          const params = {
      
              Bucket: bucketName,
              Key: delFile,
            };
          s3.deleteObject(params, (err, data) => {
              if (err) {
                console.error(err);
                return;
              }
              console.log(data);
            });
        
      }
      if(delelecoverKey){
          handleDelete(delelecoverKey);
          setDeleteFile(null);
          setcoverUrl(null);
      }

    const handleUpload = (file) => {
      fetch(file)
      .then((response) => response.blob())
      .then((blob) => {
        const file = new File([blob], 'filename.png', { type: blob.type });
        const extension = file.name.split(".").pop();
        const fileName = new Date().getTime()+"."+extension;
        const params = {
          Bucket: process.env.REACT_APP_S3_BUCKET,
          Key: upKey +"/"+fileName,
          Body: file,
        };
  
        s3.upload(params, (err, data) => {
          if (err) {
            console.error(err);
            return;
          }
          setcoverUrl(data.Location);
          setCoverKey(data.key);
        })
        .on("httpUploadcoverProgress", (evt) => {
          const coverProgressPercentage = parseInt(
            (evt.loaded * 100) / evt.total
          );
          setCoverProgress(coverProgressPercentage);
        });
      })
      .catch((error) => console.error(error));
    };

    if(uploadFile){
        handleUpload(uploadFile);
        setFile(null);
    }

    return [coverUrl,coverKey,coverProgress];
}

export default useCoverChange